
export { useDevice } from "/codebuild/output/src1269516410/src/dgbet/src/contexts/device/index.tsx"
export { useMedia } from "/codebuild/output/src1269516410/src/dgbet/src/contexts/device/index.tsx"